import { Link, useLocation } from 'react-router-dom';
import { Home, Image, TrendingUp, Settings } from 'lucide-react';
import { cn } from '@/lib/utils';

const NAV_ITEMS = [
  { path: '/business',             icon: Home,        label: 'Home'     },
  { path: '/business/activities',  icon: Image,       label: 'Activities' },
  { path: '/business/partner-stats', icon: TrendingUp, label: 'Stats'   },
  { path: '/business/settings',   icon: Settings,    label: 'Settings' },
];

export function BusinessBottomNav() {
  const { pathname } = useLocation();

  return (
    <nav className="sm:hidden fixed bottom-0 left-0 right-0 z-50 bg-white border-t border-slate-200/80 shadow-[0_-4px_12px_rgba(0,0,0,0.06)]">
      <div className="grid grid-cols-4 h-16 safe-area-inset-bottom">
        {NAV_ITEMS.map(({ path, icon: Icon, label }) => {
          const active = pathname === path || (path !== '/business' && pathname.startsWith(path));
          return (
            <Link key={path} to={path}
              className={cn(
                'relative flex flex-col items-center justify-center gap-1 transition-colors min-h-[44px]',
                active ? 'text-primary' : 'text-slate-400 active:text-slate-600'
              )}>
              {active && (
                <span className="absolute top-0 left-1/2 -translate-x-1/2 w-8 h-0.5 rounded-full bg-primary" />
              )}
              <Icon className={cn('w-5 h-5 shrink-0', active ? 'stroke-[2.2]' : 'stroke-[1.8]')} />
              <span className={cn('text-xs font-medium leading-none', active ? 'text-primary' : 'text-slate-400')}>
                {label}
              </span>
            </Link>
          );
        })}
      </div>
    </nav>
  );
}
